import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class StripeCheckoutSession extends BaseEntityModel {
  public id: string;
  public url: string;

  constructor(model: Partial<StripeCheckoutSession> = {}) {
    super(model);

    this.id = model.id as string;
    this.url = model.url as string;
  }
}
